export default __webpack_public_path__ + "static/media/GAE RAM.a19d5dea.pdf";